import React, {useState, useEffect} from 'react';
import {connect, Provider} from "react-redux";
import {getReduxStore} from "../ReduxStore/store";
import HamburgerMenu from "./HamburgerMenu";

function mapStateToProps(state) {
  const {navigationSlice = {}} = state;

  return navigationSlice;
}

let Wrapper = connect(mapStateToProps)(HamburgerMenu);

export default function HamburgerMenuApp(props) {
  return <Provider store={getReduxStore()}>
    <Wrapper {...props} />
  </Provider>
}
